const {Component} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");
const IntegerField = require("components/forms/IntegerField");
const Input = require("components/forms/Input");

class Achievement extends Component {

	static get propTypes() {
		return {
			value: PropTypes.object,
			error: PropTypes.object,
			onChange: PropTypes.func,
			attachmentRequired: PropTypes.bool
		}
	}

	static get defaultProps() {
		return {
			value: {},
			error: {}
		}
	}

	constructor(props) {
		super(props);

		// populate state
		const achievement = props.value || {};

		this.state = {
			name: achievement.value || "",
			year: achievement.obtained_at ? moment(achievement.obtained_at).year() : ""
		};
	}

	get className() {
		let classList = ["achievement-field"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	get required() {
		return this.props.required === true;
	}

	get attachmentRequired() {
		return typeof this.props.attachmentRequired === "boolean" ?
			this.props.attachmentRequired : this.required;
	}

	get attachment() {
		return this.props.value.attachment;
	}

	inputName(name) {
		if (typeof this.props.name === "string") {
			return `${this.props.name}[${name}]`;
		}
	}

	onChange(name) {
		return e => {
			const value = e.target.value;

			this.setState(
				state => {
					state[name] = value;
					return state;
				},
				() => {
					if (typeof this.props.onChange === "function") {
						this.props.onChange(this.state);
					}
				}
			);
		};
	}

	normalizeYear(value) {
		return value && (value.length > 0) ? parseInt(value).toString() : "";
	}

	renderAttachmentField() {
		const attachment = this.attachment;
		const linkMarkup = attachment ? (
			<a className="view-current" target="_blank" href={attachment.url}>Se nuværende</a>) : null;

		return (
			<Input type="file" label="Eksamensbevis fra gymnasial uddannelse" name={this.inputName("attachment")} error={this.props.error.attachment}
						 required={this.attachmentRequired} onChange={this.onChange("attachment")} accept="application/pdf,image/*">
				{linkMarkup}
			</Input>
		);
	}

	render() {
		return (
			<div className={this.className}>
				<Input label="Højst afsluttede uddannelse" name={this.inputName("name")} error={this.props.error.name}
							 required={this.required} defaultValue={this.state.name} onChange={this.onChange("name")}/>
				{this.renderAttachmentField()}
				<IntegerField label="År" name={this.inputName("year")} error={this.props.error.year} required={this.required}
											normalize={this.normalizeYear} defaultValue={this.state.year} onChange={this.onChange("year")}/>
			</div>
		);
	}

}

module.exports = Achievement;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Achievement.js